export const DEFAULT_BACKGROUND_ERROR_MESSAGE = '通信エラーが発生しました。時間をおいて再度お試しください。';

/**
 * Resolves the message to show when a background request fails.
 *
 * A network drop, timeout, CORS rejection or cancelled request leaves
 * `error.response` undefined, so reading `error.response.data` directly throws
 * from inside the catch block — the user would then see no feedback at all and
 * the button would look dead. Always returns a displayable string.
 */
export function backgroundErrorMessage(error: any): string {
  const message = error && error.response && error.response.data
    ? error.response.data.message
    : null;

  return message || DEFAULT_BACKGROUND_ERROR_MESSAGE;
}

export default backgroundErrorMessage;
